import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  ElementRef,
} from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import MousePosition from 'ol/control/MousePosition';
import { createStringXY } from 'ol/coordinate';
import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from 'ol/interaction';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OtherService } from 'src/app/Service/other.service';
import { MapService } from 'src/app/Service/map.service';
import { Location } from '@angular/common';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
declare var bootstrap: any;
declare let $: any;
@Component({
  selector: 'about',
  templateUrl: './about.component.html',
})
export class AboutComponent implements OnInit {
  constructor( private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private mapService: MapService,
    private route: ActivatedRoute,
    private gurdService: GurdServiceService,
    private _location: Location) {}
    map: any = {};

  ngOnInit(): void {

    setTimeout(() => {
    this.newOpenMap();

    }, 10);

    setTimeout(() => {


      this.map.getView().on('propertychange',  (e: any)=> {
      this.mapService.removeLayerByName('routeName', this.map);

  //  var m=  this.mapService.createMarker2(e.target.values_.center,'../../assets/Img/marker5.png',
  //    `route`,
  //    `routeName`,
  //    {
  //      html: `
  //      <p class='text-dark mb-0 f16'>${window.localStorage.getItem("commentJournal")} </p>
  //      <p class='text-dark f14'>${window.localStorage.getItem("dateJournal")}-${window.localStorage.getItem("timeJournal")}</p>
  //            `,
  //    })
  //    this.map.addLayer(m)
         });
   }, 30);

  }
  newOpenMap() {
    this.map = new Map({
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
      target: 'test',
      layers: [
        new TileLayer({
          source: new OSM({}),
        }),
      ],
      view: new View({
        center: olProj.fromLonLat([51.3833554, 35.6770113]),
        zoom: 12,
      }),
    });

    //context menu
  }
  setLocation(){
    const element = document.getElementById("myDiv") as any;
    const rect = element.getBoundingClientRect();
   var el= this.map.getCoordinateFromPixel([rect.x, rect.y])
   var marker = this.mapService.createMarker(
    ["51.397849", "35.776069"],
    '../../assets/Img/marker5.png',
    `${1}`,
    ``,
    {
      html: `
      <p class='text-dark mb-0 f16'>${this.gurdService.decrypt(window.localStorage.getItem("commentJournal")!)} </p>
      <p class='text-dark f14'>${this.gurdService.decrypt(window.localStorage.getItem("dateJournal")!)}-${this.gurdService.decrypt(window.localStorage.getItem("timeJournal")!)}</p>
            `,
    }
  );
  this.map.addLayer(marker);

  }

}
